export const statusFilter = (v, l) => {
  switch (v) {
    case '1':
      return l === '1' ? 'انتظار الدفع' : 'Awaiting Payment';
    case '8':
      return l === '1' ? 'تم شحن الشحنة' : 'Shipment Shipped';
    case '2':
      return l === '1' ? 'ألغيت' : 'Canceled';
    case '5':
      return l === '1' ? 'بانتظار الشحن' : 'Awaiting Shipping';
    case '10':
      return l === '1' ? 'الواردة' : 'Received';
    default:
      return '';
  }
};

export const dateTruncate = (v, n) => (v ? v.slice(0, n) : '');

export const dateFilter = (v) => new Date(v);
